import ReactDOM from "react-dom";
import React from "react";

import "./i18n";
import "./index.css";
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import "react-slideshow-image/dist/styles.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
